
export default abstract class PageLoadHook {
  get name(): string {
    return this.constructor.name;
  }

  public abstract onPageLoad(): void;
}
